import { useIsIcebergEnabled } from "src/hooks/useIsIcebergEnabled";
import { useWorkspaceContext } from "src/router/routerContextHooks";

/**
 * Hook to determine if Iceberg should be used for dataset generation endpoints
 *
 * Returns true if either:
 * - The workspace config `enable_dhv2_dataset_generation` is enabled, OR
 * - Falls back to the existing `useIsIcebergEnabled()` behavior
 *
 * Use this hook for dataset generation endpoints that support Iceberg reads:
 * - /dataset_jobs/api/v1/dataset_jobs
 * - /history/api/v2/decisions/export/preview
 *
 */
export const useIsIcebergDatasetGenerationEnabled = (): boolean => {
  const { workspace } = useWorkspaceContext();
  const isIcebergEnabled = useIsIcebergEnabled();

  // New flag takes precedence - when enabled, always use iceberg for dataset generation
  if (workspace.config?.enable_dhv2_dataset_generation) {
    return true;
  }

  // Fall back to existing iceberg behavior
  return isIcebergEnabled;
};
